<div class="admin-menu">
  <div class="py-4">
    <h3>Settings</h3>
  </div>
  <div *ngFor="let menu of adminMenu; trackBy: trackByMenuId">
    <div class="header-text">{{ menu.name | uppercase }}</div>
    <div class="list-group">
      <a
        *ngFor="let sub of menu.child; trackBy: trackBySubMenuRoute"
        [routerLink]="sub.routerLink"
        routerLinkActive="active"
        ><i [class]="sub.icon"></i><span>{{ sub.name }}</span><span *ngIf="sub.beta" class="sidebar-beta-badge">Beta</span></a
      >
    </div>
  </div>
</div>


<p-dialog header="Contact Details" [(visible)]="view_contact" [modal]="true" [style]="{width: '25vw'}">
  <div class="contact-section">
    <div class="contact-card">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-briefcase" style="font-size: 1.2rem; color: #32324D;"></i>
        <h4 class="m-0" style="color: #32324D;">Sales</h4>
      </div>
      <p class="m-0" style="color: #32324D;">Email : <a href="mailto:support@bizpay.co.in" style="color: #32324D; text-decoration: underline;">support&#64;bizpay.co.in</a></p>
    </div>
    <p-divider></p-divider>
    <div class="contact-card">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-headphones" style="font-size: 1.2rem; color: #32324D;"></i>
        <h4 class="m-0" style="color: #32324D;">Support</h4>
      </div>
      <p class="m-0" style="color: #32324D;">Email : <a href="mailto:care@bizpay.co.in" style="color: #32324D; text-decoration: underline;">care&#64;bizpay.co.in</a></p>
    </div>
  </div>
</p-dialog>